var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFastfood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 21.98C1.66667 22.54 2.11667 22.99 2.67667 22.99H15.6667C16.2267 22.99 16.6767 22.54 16.6767 21.98V21H1.66667V21.98ZM9.16667 8.99C5.41667 8.99 1.66667 11 1.66667 15H16.6667C16.6667 11 12.9167 8.99 9.16667 8.99ZM4.28667 13C5.39667 11.45 7.75667 10.99 9.16667 10.99C10.5767 10.99 12.9367 11.45 14.0467 13H4.28667ZM1.66667 17H16.6667V19H1.66667V17ZM18.6667 5V1H16.6667V5H11.6667L11.8967 7H21.4567L20.0567 21H18.6667V23H20.3867C21.2267 23 21.9167 22.35 22.0167 21.53L23.6667 5H18.6667Z",
    fill: "#5D5FEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastfood);
export default __webpack_public_path__ + "static/media/Fastfood.bc87e7d96eec9a888dc0e3e2932da3dd.svg";
export { ForwardRef as ReactComponent };